import ToggleWeightCost from "@/components/toggleWeightCost/toggleWeightCost.vue";
import { REQUEST_STATE } from "@/enums";
import { createNamespacedHelpers } from "vuex";

const { mapGetters: userGetters } = createNamespacedHelpers("user");

export default {
	components: { ToggleWeightCost },

	props: {
		categories: {
			type: Array,
			required: true,
		},

		state: {
			type: String,
			validator(requestState) {
				return Object.keys(REQUEST_STATE).includes(requestState);
			},
		},
	},

	data() {
		return {
			REQUEST_STATE,
			// if false than kg filter is active else filter by currency
			isCostToggleActive: false,
		};
	},

	computed: {
		...userGetters(["activeOutlet", "weightUnit"]),

		topCategories,
	},

	methods: { translate },
};

function topCategories() {
	const SLICE_START = 0,
		SLICE_END = 5;

	if (this.isCostToggleActive) return this.$utils.sortDesc(this.categories, "cost").slice(SLICE_START, SLICE_END);

	return this.$utils.sortDesc(this.categories, "gross_weight").slice(SLICE_START, SLICE_END);
}

function translate(category) {
	const locale = localStorage.getItem("language") || "en",
		categoryTranslation = category.translations.find((translation) => translation.language_code === locale);
	return categoryTranslation.category_name;
}
